// External libs
import { createSelector } from 'reselect';
// Consts
import { textIds } from '../consts';
// Tools
import { formatMessage } from '../../../intl/intl';
// Selectors
import { selectors as itemsDeactivationStockOutIssueDialogSelectors } from '../../../redux/items-deactivation-stock-out-issue-dialog';

const selectTitle = createSelector<any, number, string>(
  itemsDeactivationStockOutIssueDialogSelectors.selectOrderId,
  orderId => formatMessage(textIds.title, { orderId }),
);

const selectors = { selectTitle };

export default selectors;
